import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/mini-site")({
  ssr: false,
  // Use getSession() (reads from local storage synchronously when cached)
  // instead of getUser() which always hits the network and blocks navigation.
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: "/auth" });
    }
  },
  component: () => <Outlet />,
});
